
import React from 'react';
import {
    createStyles, Grid, makeStyles, Button, Theme, Box, TextField,
} from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import CommentIcon from '@material-ui/icons/Comment';
import { useDispatch } from "react-redux";
import { useAppData } from '../../services/hooks';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import {
    submitDataAction
} from '../toolDisposalSlice';
import Edit from '@material-ui/icons/Edit';

export const ApproveCommentModel = () => {
    const dispatch = useDispatch();
    const row = useAppData((r) => r.toolDisposalSlice.updateValues.value);
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [text, setText] = React.useState("");

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    const onClickConfirm = () => {
        const { ...rowdata } = row
        dispatch(
            submitDataAction({
                body: {
                    ...rowdata,
                    "notes": text,
                },
            }),
        );
        setOpen(false);
    };


    return (
        <>
            <div>
                
                {row.notes ? ((row &&  (row.disposalStatusId === "2" || row.disposalStatusId === "3" || row.disposalStatusId === "4")) ? <>{row.notes}<Edit color={'secondary'} /></> :
                    <>{row.notes}<Edit onClick={handleOpen} color={'primary'} /></>) :
                    <Button
                        onClick={handleOpen}
                        disabled={(row &&  (row.disposalStatusId === "2" || row.disposalStatusId === "3" || row.disposalStatusId === "4")) ? true : false }
                        data-tut={'reactour__addNote'}
                        variant={'outlined'}
                        color={'primary'}
                        startIcon={<CommentIcon />}
                    >
                        Add Note
                    </Button>}

                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal}
                    open={open}
                    onClose={handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={open}>

                        <Card className={classes.root}>
                            <CardContent>
                                <Box mb={2}>
                                    <Typography variant="h5" component="h2">
                                        Add Notes
                                    </Typography>
                                </Box>

                                <Box px={2}>

                                    <TextField
                                        className={classes.textField}
                                        error={false}
                                        autoFocus
                                        // value={row}

                                        helperText={
                                            false
                                                ? 'You have reached the maximum character limit'
                                                : null
                                        }
                                        inputProps={{ maxLength: 300 }}
                                        multiline
                                        variant="outlined"
                                        margin="dense"
                                        id="id"
                                        label="Comments"
                                        rows={4}
                                        type="text"
                                        fullWidth
                                        onChange={(e) => {
                                            setText(e.target.value)
                                        }}
                                    />

                                </Box>




                                <Box my={2}>
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="space-between"
                                        alignItems="center"
                                    >
                                        <Button
                                            className={classes.button}
                                            data-tut={'reactour__download-Button'}
                                            variant="contained"
                                            color="primary"
                                            disabled={false}
                                            onClick={onClickConfirm}

                                        >
                                            CONFIRM
                                        </Button>
                                        <Button
                                            className={classes.button}
                                            data-tut={'reactour__download-Button'}
                                            variant="outlined"
                                            color="primary"
                                            disabled={false}
                                            onClick={handleClose}

                                        >
                                            Cancel
                                        </Button>
                                    </Grid>

                                </Box>
                            </CardContent>

                        </Card>

                    </Fade>
                </Modal>
            </div>

        </>
    );
};




const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },


        root: {
            minWidth: 300,
            padding: 12,
            
        },

        button: {
            minWidth: '7.188rem',
        },

        textField: {
            "& .MuiFormLabel-root": {
              color: "inherit",
            },
            minWidth: 300,
            padding: 12,
          },







    }),
);

